angular.module('app').requires.push('ngMask');
angular.module('app').controller('CampanhaDoarController', function ($scope, $http, vcRecaptchaService) {
    $scope.campanha = {};
    $scope.doacao = {
        movimentacao: {}
    };
    $scope.usuarioLogado = false;
    $scope.valores = [];
    $scope.outroValor = '';
    $scope.validadoNaReceita = false;
    $scope.usuarioLogadoData = {};

    $scope.initFormDoacao = function () {
        $scope.doacao.movimentacao.valor_liquido = $scope.valores[0] ? $scope.valores[0] : '';
        $scope.doacao.movimentacao.nr_parcelas = 1;
        $scope.doacao.doacao_em_nome_empresa = 0;
        $scope.doacao.doacao_anonima = 0;

        $scope.doacao.aceita_receber_emails_marketing = true;
        $scope.doacao.concordo_termos_uso = true;
        $scope.doacao.is_recorrente = false;
        $scope.initByUsuarioLogado();
    }

    $scope.initByUsuarioLogado = function () {
        $http({
            method: 'GET',
            url: 'restrito/usuarios/me',
            ignorarCatchInterceptor: true,
        }).then(function (res) {
            $scope.usuarioLogado = true;
            $scope.usuarioLogadoData = res.data;
            if (res.data.tipo == 'J') {
                if (!$scope.campanha.is_politica) {
                    $scope.doacao.cpf_cnpj = res.data.cpf_cnpj;
                    $scope.doacao.nome = res.data.razao_social;
                    $scope.doacao.responsavel_nome = res.data.responsavel_nome;
                    $scope.doacao.responsavel_cpf = res.data.responsavel_cpf;
                    $scope.doacao.doacao_em_nome_empresa = true;
                } else {
                    $scope.doacao.cpf_cnpj = res.data.responsavel_cpf;
                    $scope.doacao.nome = res.data.responsavel_nome;
                }
            } else {
                $scope.doacao.cpf_cnpj = res.data.cpf_cnpj;
                $scope.doacao.nome = res.data.name;
            }

            $scope.doacao.email = res.data.email;

            $scope.doacao.data_nascimento = res.data.data_nascimento;
            $scope.doacao.celular = res.data.celular;
            $scope.doacao.cep = res.data.cep;
            $scope.doacao.logradouro = res.data.logradouro;
            $scope.doacao.numero = res.data.numero;
            $scope.doacao.complemento = res.data.complemento;
            $scope.doacao.bairro = res.data.bairro;
            $scope.doacao.uf = res.data.uf;
            $scope.doacao.municipio_id = res.data.municipio_id;
            $scope.validadoNaReceita = (res.data.receita_federal_consulta_id || res.data.validado_rf_manualmente_responsavel_id);
        })
    }

    $scope.setValor = function (valor, opcaoPreDefinida) {
        $scope.doacao.movimentacao.valor_liquido = valor;
        if (opcaoPreDefinida) {
            $scope.outroValor = null;
        }
    }

    $scope.isValorEscolhido = function (valor) {
        if (valor == $scope.doacao.movimentacao.valor_liquido) {
            return true;
        }

        return false;
    }

    $scope.setRecaptchaId = function (recaptchaId) {
        $scope.recaptchaId = recaptchaId;
    };

    $scope.onRecaptchaSuccess = function(response){

        $scope.salvando = true;

        let data = $scope.doacao;
        data.visitor_id = window.visitorID;
        data.recaptcha_response = response;

        $http({
            'url': window.location.href,
            'method': 'post',
            'data': data,
            'ignorarCatchInterceptor': true
        }).then(function (res) {
            if (res.data.status === 1) {
                window.location.href = window.location.href.substr(0, window.location.href.length - 5) + '/doacoes/' + res.data.doacao_id + '/sucesso';
            } else {
                vcRecaptchaService.reload($scope.recaptchaId);
            }
        }).catch(function (res) {
            $scope.salvando = false;
            vcRecaptchaService.reload($scope.recaptchaId);
            switch (res.status) {
                case 402:
                    angular.element('#modal-pagamento-nao-autorizado').modal();
                    break;
                case 422:
                    var erros = '';

                    var msg = res.data.mensagem ? res.data.mensagem : res.data.msg;

                    if (typeof res.data != 'string' && typeof msg != 'string') {
                        angular.forEach(res.data, function (value) {
                            for (var j = 0; j < value.length; j++) {
                                erros += value[j] + '<br>';
                            }
                        });
                    } else {
                        erros += msg ? msg : res.data;
                    }

                    $.gritter.add({
                        title: 'Erro ao processar requisição',
                        text: erros,
                        time: 10000,
                        class_name: 'erro'
                    });

                    break;
                default:
                    //erro interno no servidor
                    var msg = 'Erro ' + res.status + ': ' + res.statusText;
                    console.error(msg, res);
                    $.gritter.add({
                        title: 'Erro ao processar requisição',
                        text: msg,
                        time: 10000,
                        class_name: 'erro'
                    });
                    break;
            }
        })
    }

    $scope.save = function (e) {
        e.preventDefault();

        vcRecaptchaService.execute($scope.recaptchaId);
    }

    $scope.changeDoacaoEmpresa = function () {
        var old = angular.copy($scope.doacao);

        if (!$scope.usuarioLogado) {

            if ($scope.doacao.doacao_em_nome_empresa) {
                $scope.doacao.responsavel_cpf = old.cpf_cnpj;
                $scope.doacao.responsavel_nome = old.nome;
                $scope.doacao.cpf_cnpj = null;
                $scope.doacao.nome = null;

            } else {
                $scope.doacao.responsavel_cpf = null;
                $scope.doacao.responsavel_nome = null;
                $scope.doacao.cpf_cnpj = old.responsavel_cpf;
                $scope.doacao.nome = old.responsavel_nome;
            }
        } else {
            if ($scope.doacao.doacao_em_nome_empresa) {
                if ($scope.usuarioLogadoData.tipo == 'J') {
                    $scope.doacao.responsavel_cpf = $scope.usuarioLogadoData.responsavel_cpf;
                    $scope.doacao.responsavel_nome = $scope.usuarioLogadoData.responsavel_nome;
                    $scope.doacao.cpf_cnpj = $scope.usuarioLogadoData.cpf_cnpj;
                    $scope.doacao.nome = $scope.usuarioLogadoData.name;
                } else {
                    $scope.doacao.responsavel_cpf = $scope.usuarioLogadoData.cpf_cnpj;
                    $scope.doacao.responsavel_nome = $scope.usuarioLogadoData.name;
                    $scope.doacao.cpf_cnpj = null;
                    $scope.doacao.nome = null;
                }

            } else {
                $scope.doacao.responsavel_cpf = null
                $scope.doacao.responsavel_nome = null
                if ($scope.usuarioLogadoData.tipo == 'J') {
                    $scope.doacao.cpf_cnpj = $scope.usuarioLogadoData.responsavel_cpf;
                    $scope.doacao.nome = $scope.usuarioLogadoData.responsavel_nome;
                } else {
                    $scope.doacao.cpf_cnpj = $scope.usuarioLogadoData.cpf_cnpj;
                    $scope.doacao.nome = $scope.usuarioLogadoData.name;
                }
            }
        }
    };

});
